import { h } from 'preact'
import { IconComponentProps } from './index'

export default ({ width = 16, height = 16, color = 'currentColor', customClass = '' }: IconComponentProps) => (
  <svg width={width} height={height} viewBox='0 0 16 16' fill='none' xmlns='http://www.w3.org/2000/svg'>
    <path d='M14.0002 2.66699H2.00016C1.6335 2.66699 1.3335 2.96699 1.3335 3.33366V12.667C1.3335 13.0337 1.6335 13.3337 2.00016 13.3337H14.0002C14.3668 13.3337 14.6668 13.0337 14.6668 12.667V3.33366C14.6668 2.96699 14.3668 2.66699 14.0002 2.66699ZM5.3335 12.0003H2.66683V4.00033H5.3335V12.0003ZM9.3335 12.0003H6.66683V4.00033H9.3335V12.0003ZM13.3335 12.0003H10.6668V4.00033H13.3335V12.0003Z' fill={color} />
  </svg>
)
